import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  { path: 'center', lazy: async () => ({ Component: (await import('./CenterPage')).CenterPage }) },
];
